import React from 'react'

export default function SearchIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.927 14.0396L17.4001 17.3996M16.2801 8.43961C16.2801 12.7695 12.77 16.2796 8.4401 16.2796C4.11019 16.2796 0.600098 12.7695 0.600098 8.43961C0.600098 4.1097 4.11019 0.599609 8.4401 0.599609C12.77 0.599609 16.2801 4.1097 16.2801 8.43961Z" stroke="#767676" strokeLinecap="round"/>
    </svg>
  )
}
